import { Component, Directive, ChangeDetectionStrategy, ViewEncapsulation,AfterViewInit, Inject, PLATFORM_ID, ElementRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';

import { EXPERIMENTS, ExperimentModel, ABTestingSelectionStrategy } from './shared/abtesting.service';

import { debounceTime } from 'rxjs/operators';

import { Cookie, CookieBrowser } from './shared/cookie.service';
import { HttpCssClient } from './shared/http-request.interceptor';
import { HeaderService } from './shared/header.service';
import { CurrencyService } from './shared/currency.service';
import { LocationService } from './services/location.service';
import { AccentsUtils } from './shared/accents-utils.service';
import { OnInit } from '@angular/core/src/metadata/lifecycle_hooks';
import { AnalyticsUtilsService } from './shared/analytics-utils.service';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { ABTestingDirective } from './shared/abtesting.service';
import { TransferState, makeStateKey } from '@angular/platform-browser';
import { Subscription } from 'rxjs';
import { WindowScrollService } from './shared/window-sroll.service';
import { ScrollService } from './shared/scroll-service';
import { SearchResult, LocationSearchResult, ProductSearchResult } from './models/search-result.model';

declare var dataLayer;
const STATE_KEY = makeStateKey('universal_cache');
@Component({
  changeDetection: ChangeDetectionStrategy.Default,
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['../assets/css/main.scss', '../assets/css/basic.scss', '../assets/css/theme.scss', '../assets/css/form.scss', '../assets/css/text.scss', '../assets/css/summary.scss'],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent implements OnInit{
  public basketElements:number = null;
  public currLang:string;
  public currency:number;
  public locale:string;
  public searchResults:SearchResult;
  public searchText:string;
  public cityText:any;
  public searchingLocations:FormControl = new FormControl();
  public searchIsOpened:boolean = false;
  public secondBarIsOpened:boolean = false;
  public contactUrl:string;
  public termsUrl:string;
  public homeLink:string = '/';
  public cookiesAccepted:boolean = false;
  public scrollSubscription:Subscription = null;
  public showUpButton:boolean = false;
  public noResults:boolean = false;

  //----------------------------------------------------- Construct -------------------------------------------------------//
  constructor(private route: Router,
    private router:ActivatedRoute,
    private cookie:Cookie,
    public headerService:HeaderService,
    private translate:TranslateService,
    private http:HttpCssClient,
    private analytics: AnalyticsUtilsService,
    public currencyService:CurrencyService,
    private locationService:LocationService,
    private accentsUtils:AccentsUtils,
    private state: TransferState,
    @Inject(PLATFORM_ID) private platformId:Object,
    @Inject(EXPERIMENTS) private experiments:ExperimentModel[],
    private analyticsUtils:AnalyticsUtilsService,
    private strategy:ABTestingSelectionStrategy,
    private transferState: TransferState,
    private windowScroll:WindowScrollService,
    private scrollService:ScrollService,
    private element:ElementRef
  ){
    this.loadTest();
    this.headerService.numElementsCart = parseInt(this.cookie.get()["guest_cart_element"]) || 0;
    this.currency = 1;

    this.searchingLocations.valueChanges.pipe(debounceTime(1000)).subscribe(query =>{
      if(query != null && query.length >= 3){
        this.locationService.searchLocation({query: query}).subscribe(results => {
          this.searchResults = results.body;
          this.noResults = this.searchResults == null;
        });
      }else if(query == null || query.length == 0){
        if(this.searchResults){
          this.searchResults.locations = [];
          this.searchResults.products = [];
        }
      }
    });

    if(this.cookie.get()['currency']){
      this.currency = this.cookie.get()['currency'];
      this.currencyService.setCurrencyStr(this.currency); 
    }else{
      if (isPlatformBrowser(this.platformId)){
        this.currency = 1;
        this.currencyService.setCurrencyStr(this.currency);
        // this.currencyService.getCountryByIp().subscribe(response => {
        //   this.currency = this.currencyService.findCurrencyByGeolocation(response['country_code']);
        //   this.currencyService.setCurrencyStr(this.currency);
        // },
        // error => {/*let the default lang and currency*/}
      // );
      }
    }

    if (isPlatformServer(this.platformId)){
      this.cookiesAccepted = true;
    }

    if(this.cookie.get()['isagent'] == 'true'){
      this.headerService.setIsAgent(true);
      this.headerService.setAgentCredit(this.cookie.get()["agent_credit"]);
    }
  };
  ////////////////////////////////////////////////////////////////////////////////////////////////////////


  searchWord(search:string){
    let productFind:boolean = false;
    if(this.searchResults) {
      if(this.searchResults.locations.length > 0 ){
        if(this.searchResults.locations.length == 1 && this.searchResults.products.length == 0){
          this.navToCity(this.searchResults.locations[0]);
        } else {
          this.searchResults.locations.map(city => {
            if(this.accentsUtils.removeAccents(city.location).toLowerCase().includes(search.toLowerCase()))
              this.navToCity(city);
          });
        }
      } 
      if(this.searchResults.products.length > 0){
        if(this.searchResults.products.length == 1){
          this.navToProduct(this.searchResults.products[0]);
        } else {
          this.searchResults.products.map(product => {
            if(product.name == search){
              productFind = true;
              this.navToProduct(product);
            }
          });
          if(!productFind) {
            this.navToProduct(this.searchResults.products[0])
          }
        }
      }
    }
  }

  public transformUrl(urlToTranslate):any{
   return this.translate.get(urlToTranslate);
  }

  public goBasket(){
    this.translate.get('BASKET_URL').subscribe(basket => {
      let url = `/${this.translate.currentLang}/${basket}`;
      this.route.navigate([url]);
    });
  }

  public changeLanguage(lang:any){
    try 
    {
      let new_url:string;
      let regex = /^(\/\w+)(\/)/
      let currentLang = this.cookie.get()['language'];
      //Static pages have a property called localeTag configured in Router         
      let localizationTag = this.router.firstChild.data['value']['localeTag'];      
      this.cookie.put('language',lang);
      this.translate.use(lang).subscribe(e => {
      let new_url = "";
      if (localizationTag && localizationTag != '')
      {
        //We are in a static URL
        new_url = lang + '/' + this.translate.instant(localizationTag)
      }
      else
      {        
        if(regex.test(this.route.url)){
          new_url = this.route.url.replace(regex,`/${lang}$2`);
        }
      }
        this.route.navigate([new_url]);
      });
    }
    catch (ex)
    {
      console.log(ex);
    }
  }

  public changeCurrency(currency:number){
    if(this.cookie.get()['guest_cart_element'] != null && parseInt(this.cookie.get()['guest_cart_element']) > 0){
      this.currencyService.updateCurrency({id:currency}).subscribe(message => {
        this.currencyService.setCurrencyStr(currency);
        this.cookie.put("currency",`${currency}`);
      });
    }else{
      this.currencyService.setCurrencyStr(currency);
      this.cookie.put("currency",`${currency}`);
    }
    
  }

  private navToProduct(product:ProductSearchResult){
    let lang = this.translate.currentLang;
    let nameCity = this.accentsUtils.transformUrl(product.location.name);
    let nameProduct = this.accentsUtils.transformUrl(product.name);

    this.route.navigate([`/${lang}/${product.location.id}/${nameCity}/${product.id}/${nameProduct}`]);
    this.searchText = "";
    this.searchingLocations.reset();
    this.searchResults.locations = [];
    this.searchResults.products = [];
  }

  private navToCity(location:LocationSearchResult){
    let lang = this.translate.currentLang;
    let name = this.accentsUtils.transformUrl(location.location);

    this.route.navigate([`/${lang}/${location.id}/${name}`]);

    this.searchText = "";
    this.searchingLocations.reset();
    this.searchResults.locations = [];
    this.searchResults.products = [];
  }

  private handleScroll(currentScroll){
    if(currentScroll < 650){
      this.showUpButton = false;
    }
    else if (currentScroll == 0){
      this.showUpButton = false;
    }
    else {
      this.showUpButton = true;
    }
  }

  private moveToUp() {
    let posX = this.element.nativeElement.querySelector('#main-header').getBoundingClientRect().top;
    this.scrollService.scrollTo(posX);
  }


  private logout(){
    this.cookie.remove("guest_session");
    this.cookie.remove("isagent");
    this.headerService.setIsAgent(false);
    this.headerService.setAgentCredit(0);
    this.route.navigate([`/`]);
  }

  public toggleSearch(){
    this.searchIsOpened = !this.searchIsOpened;
  }
  public toggleSecondBar(){
    this.secondBarIsOpened = !this.secondBarIsOpened;
  }
  
  ngOnInit(){    
    this.translate.onLangChange.subscribe((params: LangChangeEvent) => {
      this.homeLink = `/${params.lang}/home`;
    });
    if (isPlatformBrowser(this.platformId))
    {
      //Read cookie for consent
      let cookies = new CookieBrowser();
      if (cookies.get()["CONSENT"] != null)
      {
        this.cookiesAccepted = true;
      }
      this.scrollSubscription = this.windowScroll.scroll$.subscribe(this.handleScroll.bind(this));
    }
  }

  clickOnNewsletter() {
    this.analytics.click_on_newsletter();
  }

  acceptCookies() {
    this.cookiesAccepted = true;
    //setting the cookie:
    let cookies = new CookieBrowser();
    cookies.put("CONSENT", "1",1000*60*60*24*600);  
    this.analyticsUtils.click_on_cookies();  
  }

  //////////////////////////////////////// A/B TESTING
  /**
   * Priority of values:
   *  - SERVER SIDE:
   *   1 - cookie
   *   2 - Strategy
   *  
   *  - BROWSER SIDE:
   *   1 - Cookie
   *   2 - state transfer value
   *   3 - strategy value
   */
 loadTest(){
    this.experiments.forEach(e => {        
        let key = makeStateKey<string>(e.experimentName);
        let version = '';
        try{
          //The value of the cookie is the one with highest priority 
          if (this.cookie.get()[`AB_${e.experimentName}`])
          {
            version = this.cookie.get()[`AB_${e.experimentName}`];
          }
          else
          {
            version = this.strategy.selectVersionDisplayed(e.experimentName);
          }
          
          //In server side we have to put the key in transfer state.
          if (isPlatformServer(this.platformId)){
            this.transferState.onSerialize(key, () => {return version});
          }
          else{
            //In browser we have to check if there is any key from server side
            if (this.transferState.hasKey(key)){               
              version = this.transferState.get(key, "A");
            }
            //Notify tag manager.
            dataLayer.push({
              'event': 'A/B',
              'eventCategory': 'A/B Testing',
              'eventAction': `${e.experimentName}`,
              'eventLabel': `${version}`,
              'eventValue': `${version}`
          });
          }
          if(!this.cookie.get()[`AB_${e.experimentName}`]){
            this.cookie.put(`AB_${e.experimentName}`,`${version}`,31536000000);            
          }
        }catch(e){}
    });
  }
}
